<script setup lang="ts">
import type { FreeShippingLoaderProps } from "./FreeShippingLoader.props"

const props = defineProps<FreeShippingLoaderProps>()

const isFreeShipping = computed(
  () => props.remainingAmount === undefined || props.remainingAmount <= 0
)

const progressPercentage = computed(() => {
  if (isFreeShipping.value || !props.thresholdAmount) {
    return 100
  }
  const currentAmount = props.thresholdAmount - (props.remainingAmount ?? 0)
  return Math.min(
    100,
    Math.max(0, (currentAmount / props.thresholdAmount) * 100)
  )
})

const formattedRemainingAmount = computed(() => {
  if (!props.remainingAmount || props.remainingAmount <= 0) {
    return "0,00"
  }
  return props.remainingAmount.toFixed(2).replace(".", ",")
})
</script>

<template>
  <div
    class="cart-utils-free-shipping-loader md:bg-grey-main rounded-md md:p-2"
  >
    <div class="flex items-center gap-2">
      <UtilsIcon
        v-if="isFreeShipping"
        name="CheckmarkCircle2.svg"
        color="green-main"
        class="h-4 w-4 shrink-0"
      />
      <UtilsIcon
        v-else
        name="Car.svg"
        color="yellow-main"
        class="h-4 w-4 shrink-0"
      />
      <p class="mouse-bold">
        <template v-if="isFreeShipping">
          {{ $t("organism.cart.freeShipping.achieved") }}
        </template>
        <template v-else>
          {{
            $t("organism.cart.freeShipping.remainingAmount", {
              formattedRemainingAmount
            })
          }}
        </template>
      </p>
    </div>
    <div
      class="mt-2 h-1 w-full overflow-hidden rounded-full"
      :class="isFreeShipping ? 'bg-green-main' : 'bg-yellow-30'"
    >
      <div
        class="h-full rounded-full transition-all duration-300"
        :class="isFreeShipping ? 'bg-green-main' : 'bg-yellow-main'"
        :style="{ width: `${progressPercentage}%` }"
      />
    </div>
  </div>
</template>
